/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Changelog_Admin_TitleInputs */

const fr_changelog_admin_title = /** @type {(inputs: Changelog_Admin_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion du changelog`)
};

/**

* @param {Changelog_Admin_TitleInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const changelog_admin_title = /** @type {((inputs?: Changelog_Admin_TitleInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Changelog_Admin_TitleInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_changelog_admin_title(inputs)
});